import script from "./ConstructorMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorMain.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorMain.vue?vue&type=style&index=0&id=47e13d66&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e13d66"]])

export default __exports__